module.exports = __webpack_public_path__ + "static/media/clock-protocolo.7e1ab761.png";